export default {
  name: 'marking--certificateType',
};